import * as React from 'react';
import { Button } from 'react-bootstrap';
import { AddCoHostModal } from './AddCoHostModal';
import { Users } from 'lucide-react';
interface AddCoHostButtonProps {
  eventId: number;
}

export const AddCoHostButton = (props: AddCoHostButtonProps) => {
  const [show, setShow] = React.useState(false);

  return (
    <>
      <Button
        variant="primary"
        className="d-flex justify-content-start  align-items-center gap-1"
        size="sm"
        onClick={() => setShow(true)}
      >
        <Users size={14} />
        Add Co-Host
      </Button>
      <AddCoHostModal eventId={props.eventId} show={show} setShow={setShow} />
    </>
  );
};
